import { connect } from 'react-redux';
import { useEffect } from 'react';
import { Spinner } from '@fluentui/react-components';

// component functions
import * as ComponentFunctions from './ConsumptionTotal.Functions';
import { ProtocolConsumptionTotal } from '../../../models/Entities/Protocols/ProtocolConsumptionTotal';

import './ConsumptionTotal.Styles.css';

const formatAmount = (amount: number | undefined, currency: string | undefined) => {
    try {
        return (amount ?? 0).toLocaleString('es-AR', {
            style: 'currency',
            currency: (currency || 'ARS').toUpperCase(),
        });
    } catch {
        return `${(currency || 'ARS').toUpperCase()} ${(amount ?? 0).toFixed(2)}`;
    }
};

const ProtocolTotalsComponent = (props: ComponentFunctions.Props) => {

    useEffect(() => {
        props.GetTotalsByStatus(props.ProtocolId, props.status);
    }, [props.protocol != null, props.NeedUpdating]);

    const statusClass = ComponentFunctions.GetStatusClass(props.status);
    const statusDescription = ComponentFunctions.GetStatusDescription(props.status);
    const hasTotals = props.Totals && props.Totals.length > 0;
    const currencyCount = props.Totals?.length ?? 0;

    return (
        <div className={'protocolTotals ' + statusClass} key={props.status}>
            <div className='protocolTotals__header'>
                <span className='protocolTotals__dot' aria-hidden='true' />
                <span className='protocolTotals__label'>{statusDescription}</span>
                {currencyCount > 1 && (
                    <span className='protocolTotals__chip' title={`${currencyCount} monedas`}>
                        {currencyCount}
                    </span>
                )}
                {props.isLoading && (
                    <span className='protocolTotals__spinner'>
                        <Spinner size='extra-tiny' />
                    </span>
                )}
            </div>
            <div className='protocolTotals__body'>
                {hasTotals ? (
                    props.Totals.map((total: ProtocolConsumptionTotal) => (
                        <div className='protocolTotals__amountRow' key={total.currencyCode}>
                            <span className='protocolTotals__currency'>
                                {(total.currencyCode || 'ARS').toUpperCase()}
                            </span>
                            <span className='protocolTotals__amount'>
                                {formatAmount(total.totalAmount, total.currencyCode)}
                            </span>
                        </div>
                    ))
                ) : (
                    <div className='protocolTotals__amountRow protocolTotals__amountRow--empty'>
                        <span className='protocolTotals__currency'>ARS</span>
                        <span className='protocolTotals__amount protocolTotals__amount--empty'>
                            {formatAmount(0, 'ARS')}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ProtocolTotalsComponent as any);
